import { render } from "./SearchFormForDate.vue?vue&type=template&id=ee90584c"
import script from "./SearchFormForDate.vue?vue&type=script&lang=ts"
export * from "./SearchFormForDate.vue?vue&type=script&lang=ts"

import "./SearchFormForDate.vue?vue&type=style&index=0&id=ee90584c&lang=scss"
script.render = render

export default script